import React from "react";
import {
  Flag,
  Layers,
  Message,
  Image as ImageIcon,
  VideoLibrary,
  MusicNote,
  Description,
  Label,
  LabelOff,
  Input,
  Menu,
  Code,
  Http,
  CompareArrows,
  Timer,
  Keyboard,
  Settings,
  Forward,
  Assignment,
} from "@material-ui/icons";

export const nodeCategories = {
  events: {
    title: "Events",
    nodes: [
      {
        type: "start",
        label: "Start",
        icon: <Flag />,
        color: "#9c88ff",
        description: "Nodo inicial del flujo",
      },
    ],
  },
  contenedor: {
    title: "Contenedor",
    nodes: [
      {
        type: "content",
        label: "Bloque de Respuesta",
        icon: <Layers />,
        color: "#5c35d4",
        description: "Agrupa múltiples contenidos en un solo nodo (texto, imagen, audio, video, intervalo)",
      },
    ],
  },
  bubbles: {
    title: "Bubbles",
    nodes: [
      {
        type: "text",
        label: "Texto",
        icon: <Message />,
        color: "#2196F3",
        description: "Enviar mensaje de texto",
      },
      {
        type: "image",
        label: "Imagen",
        icon: <ImageIcon />,
        color: "#4CAF50",
        description: "Enviar imagen con caption",
      },
      {
        type: "video",
        label: "Video",
        icon: <VideoLibrary />,
        color: "#FF5722",
        description: "Enviar video con caption",
      },
      {
        type: "audio",
        label: "Audio",
        icon: <MusicNote />,
        color: "#9C27B0",
        description: "Enviar audio con caption",
      },
      {
        type: "document",
        label: "Documento",
        icon: <Description />,
        color: "#607D8B",
        description: "Enviar documento con caption",
      },
      {
        type: "tag",
        label: "Agregar Tag",
        icon: <Label />,
        color: "#4CAF50",
        description: "Agregar tag al ticket",
      },
      {
        type: "removeTag",
        label: "Remover Tag",
        icon: <LabelOff />,
        color: "#F44336",
        description: "Remover tag del ticket",
      },
    ],
  },
  inputs: {
    title: "Inputs",
    nodes: [
      {
        type: "input",
        label: "Input",
        icon: <Input />,
        color: "#ff6b35",
        description: "Solicitar input del usuario",
      },
      {
        type: "menu",
        label: "Menú",
        icon: <Menu />,
        color: "#ff6b35",
        description: "Mostrar menú con opciones (respuesta por texto)",
      },
      {
        type: "buttons",
        label: "Botones WA",
        icon: <Menu />,
        color: "#075e54",
        description: "Botones interactivos nativos de WhatsApp (quick reply, URL, copiar)",
      },
      {
        type: "hsmTemplate",
        label: "Plantilla HSM",
        icon: <Assignment />,
        color: "#128C7E",
        description: "Enviar una plantilla aprobada de WhatsApp Cloud API (WABA). Ideal para iniciar o responder fuera de la ventana de 24 h.",
        wabaOnly: true, // solo visible en flujos WABA (0371 WF5)
      },
    ],
  },
  integrations: {
    title: "Integraciones",
    nodes: [
      {
        type: "openai",
        label: "Agente IA",
        icon: <Code />,
        color: "#9c88ff",
        description: "Usar Agente IA existente",
      },
      {
        type: "httpRequest",
        label: "HTTP Request",
        icon: <Http />,
        color: "#9c88ff",
        description: "Hacer petición HTTP",
      },
    ],
  },
  logic: {
    title: "Logic",
    nodes: [
      {
        type: "condition",
        label: "Condición",
        icon: <CompareArrows />,
        color: "#9c88ff",
        description: "Evaluar condición lógica",
      },
      {
        type: "wait",
        label: "Wait",
        icon: <Timer />,
        color: "#9c88ff",
        description: "Esperar tiempo antes de continuar",
      },
      {
        type: "typing",
        label: "Typing",
        icon: <Keyboard />,
        color: "#9c88ff",
        description: "Simular que el bot está escribiendo",
      },
      {
        type: "setVariable",
        label: "Set variable",
        icon: <Settings />,
        color: "#9c88ff",
        description: "Establecer variable con valor",
      },
      {
        type: "transferQueue",
        label: "Transferir a departamento",
        icon: <Forward />,
        color: "#00bcd4",
        description: "Derivar ticket a otro departamento (ej. Agente IA de Citas)",
      },
    ],
  },
};

// Array plano para compatibilidad (todos los nodos)
export const availableNodes = [
  ...nodeCategories.events.nodes,
  ...nodeCategories.contenedor.nodes,
  ...nodeCategories.bubbles.nodes,
  ...nodeCategories.inputs.nodes,
  ...nodeCategories.integrations.nodes,
  ...nodeCategories.logic.nodes,
];
